import * as React from 'react';
import { useEffect } from 'react';
import {
  setCollection,
  setCollections,
  setSentences,
  setGrammarPoints,
} from '../../../redux/modules/hanzis';
import { usePlaces } from '../../../hooks/usePlaces';
import { useSentences } from '../../../hooks/useSentences';
import { useCollections } from '../../../hooks/useCollections';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../redux/store';
import { useGrammarPoints } from '../../../hooks/useGrammarPoints';

interface DataProviderProps {
  onReady: () => void;
}

function DataProvider(props: DataProviderProps) {
  const dispatch = useDispatch();
  const places = usePlaces();
  const sentences = useSentences();
  const collections = useCollections();
  const grammarPoints = useGrammarPoints();

  const placesSelector = useSelector(
    (state: RootState) => state.hanzis.collection
  );
  const sentencesSelector = useSelector(
    (state: RootState) => state.hanzis.sentences
  );
  const collectionsSelector = useSelector(
    (state: RootState) => state.hanzis.collections
  );

  const grammarPointsSelector = useSelector(
    (state: RootState) => state.hanzis.grammarPoints
  );

  useEffect(() => {
    dispatch(setCollection(places.nodes));
  }, [places]);

  useEffect(() => {
    dispatch(setSentences(sentences.nodes));
  }, [sentences]);

  useEffect(() => {
    dispatch(
      setCollections(
        collections.nodes
          .filter((item) => item.lesson_id !== null)
          .sort((a, b) => a.lesson_id - b.lesson_id)
      )
    );
  }, [collections]);

  useEffect(() => {
    dispatch(setGrammarPoints(grammarPoints.nodes));
  }, [grammarPoints]);

  useEffect(() => {
    if (
      placesSelector.length > 0 &&
      sentencesSelector.length > 0 &&
      collectionsSelector.length > 0 &&
      grammarPointsSelector.length > 0
    ) {
      props.onReady();
    }
  }, [
    placesSelector,
    sentencesSelector,
    collectionsSelector,
    grammarPointsSelector,
  ]);

  return null;
}

export default DataProvider;
